export default "__VITE_PUBLIC_ASSET__d9afc043__"